import { getRequestHeaders } from "..";
import { ApiConfig, FileAttachment } from "../..";

type ReturnUpload = FileAttachment

interface UploadResponse {
    fileId: string
    type: string
    length: number
    originalFileName: string
}

const resolveWithVideoType = (type: string) => type.includes('video') ? 'video/mp4' : type

export const uploadFileMobileToBucket = (config: ApiConfig, token: string) => async (uri: string, name: string, fileType: string): Promise<ReturnUpload> => {   
    const apiUrl = config.API_URL + '/files/s3';
    const formData = new FormData();

    formData.append('file', {
        //@ts-ignore
        uri,
        name: name,
        type: fileType,
    });
    const options = {
        method: 'POST',
        headers: getRequestHeaders(token),
        body: formData
    }
    const response: UploadResponse = await fetch(apiUrl, options).then(res => res.json());
    
    const attachment: ReturnUpload = {
        fileName: name || response.originalFileName,
        fileSize: response.length,
        fileType: resolveWithVideoType(response.type),
        fileUid: response.fileId,
        addedOn: new Date().toISOString(),
    }
    return attachment
} 